export const CREATE_GENERIC_CASE = "CREATE_GENERIC_CASE";
